import { PAYMENT_METHOD_KEYS } from '../../../payment.constants';

export const getAdyenButtonKey = (paymentType: string): PAYMENT_METHOD_KEYS | '' => {
    switch (paymentType) {
        case 'googlepay':
            return PAYMENT_METHOD_KEYS.GOOGLE_PAY;
        case 'applepay':
            return PAYMENT_METHOD_KEYS.APPLE_PAY;
        case 'klarna_paynow':
            return PAYMENT_METHOD_KEYS.KLARNA_PAY;
        case 'sepadirectdebit':
            return PAYMENT_METHOD_KEYS.SEPA_PAY;
        case 'card':
            return PAYMENT_METHOD_KEYS.CARD;
        case 'ideal':
            return PAYMENT_METHOD_KEYS.IDEAL;
        case 'bcmc':
            return PAYMENT_METHOD_KEYS.BANCONTACT_CARD;
        case 'bcmc_mobile':
            return PAYMENT_METHOD_KEYS.BANCONTACT_MOBILE;
        default:
            return '';
    }
};

export const getPaymentMethodExtraData = (paymentType: string, state: unknown): { [key: string]: string | { [key: string]: string } } => {
    switch (paymentType) {
        case 'googlepay':
            // @ts-ignore
            return { paymentMethodToken: state?.data?.paymentMethod?.googlePayToken };
        case 'applepay':
            // @ts-ignore
            return { paymentMethodToken: state?.data?.paymentMethod?.applePayToken };
        case 'klarna_paynow':
            return {};
        case 'sepadirectdebit':
            return {
                // @ts-ignore
                iban: state?.data?.paymentMethod?.iban,
                // @ts-ignore
                ownerName: state?.data?.paymentMethod?.ownerName
            };
        case 'card':
            return {
                AdyenCard: {
                    // @ts-ignore
                    encryptedCardNumber: state?.data?.paymentMethod?.encryptedCardNumber,
                    // @ts-ignore
                    encryptedExpiryMonth: state?.data?.paymentMethod?.encryptedExpiryMonth,
                    // @ts-ignore
                    encryptedExpiryYear: state?.data?.paymentMethod?.encryptedExpiryYear,
                    // @ts-ignore
                    encryptedSecurityCode: state?.data?.paymentMethod?.encryptedSecurityCode,
                    // @ts-ignore
                    holderName: state?.data?.paymentMethod?.holderName,
                    // @ts-ignore
                    brand: state?.data?.paymentMethod?.brand
                }
            };
        case 'bcmc':
            return {
                BancontactCard: {
                    // @ts-ignore
                    encryptedCardNumber: state?.data?.paymentMethod?.encryptedCardNumber,
                    // @ts-ignore
                    encryptedExpiryMonth: state?.data?.paymentMethod?.encryptedExpiryMonth,
                    // @ts-ignore
                    encryptedExpiryYear: state?.data?.paymentMethod?.encryptedExpiryYear,
                    // @ts-ignore
                    encryptedSecurityCode: state?.data?.paymentMethod?.encryptedSecurityCode,
                    // @ts-ignore
                    checkoutAttemptId: state?.data?.paymentMethod?.checkoutAttemptId,
                    // @ts-ignore
                    brand: state?.data?.paymentMethod?.brand
                }
            };
        case 'bcmc_mobile':
            return {
                BancontactMobile: {
                    // @ts-ignore
                    checkoutAttemptId: state?.data?.paymentMethod?.checkoutAttemptId
                }
            };
        default:
            return {};
    }
};
